export enum UserRole {
  Administrator = 'Administrator',
  Finances = 'Finances',
  MemberManagement = 'MemberManagement',
}
